import { Button, CircularProgress, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { useTheme } from '@mui/material/styles'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { isEmpty, showToast, validateEmail } from '../../../utils/AppHelper'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import NoRecordFound from '../../../commonComponents/NoRecordFound'
import { logoutUser } from '../../../actions/loginActions'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import serverData from '../../../api/ServerData'
import AppButton from '../../../commonComponents/AppButton'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2
}

export default function AddUsersModal ({ data }) {
  var { open, onReload, onClose } = data
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [formError, setFormError] = useState({})
  const [loading, setLoading] = useState(false)

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [comments, setComments] = useState('')
  const theme = useTheme()

  const validateForm = () => {
    const error = {}
    if (isEmpty(firstName)) {
      error.firstName = 'Please enter first name.'
    }
    if (isEmpty(lastName)) {
      error.lastName = 'Please enter last name.'
    }
    if (isEmpty(email)) {
      error.email = 'Please enter email.'
    }
    if (!isEmpty(email) && !validateEmail(email)) {
      error.email = 'Invalid email'
    }

    if (isEmpty(comments)) {
      error.comments = 'Please enter your comments.'
    }

    setFormError(error)
    return Object.keys(error).length === 0
  }

  const handleAddUsers = async () => {
    if (validateForm()) {
      setLoading(true)
      var body = {
        firstname: firstName,
        lastname: lastName,
        email: email,
        comments: comments
      }
      serverData.addSubEmployer(
        body,
        result => {
          if (result.status) {
            showToast(result.message, false)
            onClose()
            onReload()
          } else {
            showToast(result.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          if (error.status === 401) {
            dispatch(logoutUser(navigate)) // eslint-disable-next-line
          }
        }
      )
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextBold style={{ fontSize: '24px' }}>Create sub user</TextBold>
          </Grid>
          <Grid item xs={6}>
            <TextRegular color={theme.palette.text.grey}>
              First name
            </TextRegular>
            <TextField
              name='firstName'
              value={firstName}
              onChange={e => {
                var { value } = e.target
                if (value.length < 30) {
                  setFirstName(
                    e.target.value.replace(' ', '').replace(/[^a-zA-z]/g, '')
                  )
                }
              }}
              fullWidth
              required
              error={formError.firstName}
              helperText={formError.firstName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextRegular color={theme.palette.text.grey}>Last name</TextRegular>
            <TextField
              name='lastName'
              value={lastName}
              onChange={e => {
                var { value } = e.target
                if (value.length < 30) {
                  setLastName(
                    e.target.value.replace(' ', '').replace(/[^a-zA-z]/g, '')
                  )
                }
              }}
              fullWidth
              required
              error={formError.lastName}
              helperText={formError.lastName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextRegular color={theme.palette.text.grey}>Email</TextRegular>
            <TextField
              name='email'
              value={email}
              onChange={e => {
                var { value } = e.target
                if (value.length < 50) {
                  setEmail(value)
                }
              }}
              fullWidth
              required
              type='email'
              error={formError.email}
              helperText={formError.email}
            />
          </Grid>
          <Grid item xs={6}>
            <TextRegular color={theme.palette.text.grey}>Commments</TextRegular>
            <TextField
              name='comments'
              value={comments}
              onChange={e => {
                var { value } = e.target
                if (value.length < 200) {
                  setComments(e.target.value)
                }
              }}
              fullWidth
              error={formError.comments}
              helperText={formError.comments}
            />
          </Grid>
          <Grid item>
            <AppButton
              name={'Add'}
              disabled={false}
              loading={loading}
              variant='contained'
              style={{
                textTransform: 'none',
                padding: '12px 26px',
                borderRadius: '8px'
              }}
              onClick={handleAddUsers}
            />
          </Grid>
          <Grid item>
            <Button
              disabled={loading}
              variant='text'
              style={{
                textTransform: 'none',
                padding: '12px 26px',
                borderRadius: '8px'
              }}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
